import { Link } from "react-router-dom"
import { MainLogo } from "../assets/main_logo"
import { isDesktopSize } from "utils/is-desktop";
import { useMediaQuery } from "@/hooks/use-media-query";

export const PrivacyTerms = () => {
    const isDesktop = useMediaQuery(isDesktopSize);
    return(
        <>
        <header className="flex flex-col border-b bg-background z-50">

            <div className="flex items-center mx-4 mb-1 md:my-2 lg:px-6 py-2 justify-between">
                <div className="md:w-[30%]">
                    <Link to="/"><div className="flex flex-row items-center lg:ml-8 text-white lg:text-foreground gap-2">
                        {/* <Bot size={48}/> */}
                        <MainLogo color={(isDesktop) ? "#F97316" : "#F97316"} classname="w-12" />
                        <span className={`font-bold mt-3 russo-one-regular ${(isDesktop) ? "logo-text" : "logo-text"}`} >Carri</span></div>
                    </Link>
                </div>
                <div className="flex justify-end gap-2 w-[30%]">
                    <div className="flex flex-col items-center gap-1">
                        
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div className="flex flex-col items-center justify-center w-full">
                <div className="flex flex-col items-center justify-center w-full max-w-2xl p-4 text-center">
                    <h1 className="text-2xl font-bold">Política de Privacidad y Términos de Uso</h1>
                    <div className="mt-4 text-sm space-y-6 text-left">
                        <p>
                            En Carriapp, valoramos tu privacidad y queremos que sepas cómo usamos tus datos. Esta política explica de forma simple qué información recopilamos, por qué lo hacemos y cómo la protegemos.
                        </p>
                        <ol className="list-decimal list-inside space-y-4">
                            <li>
                                <span className="font-semibold">¿Qué información recopilamos?</span>
                                <ul className="list-disc list-inside ml-5 mt-1 space-y-1">
                                    <li>Nombre y apellidos</li>
                                    <li>Correo electrónico</li>
                                    <li>Teléfono</li>
                                    <li>Comuna de residencia</li>
                                </ul>
                                <p className="mt-1">
                                    También registramos el historial de tus compras dentro de la app para ofrecerte recomendaciones y ayudarte a ahorrar más en tus compras.
                                </p>
                            </li>
                            <li>
                                <span className="font-semibold">¿Usamos servicios de terceros?</span>
                                <ul className="list-disc list-inside ml-5 mt-1 space-y-1">
                                    <li>
                                        Google Analytics para entender cómo usas el sitio y mejorarlo.
                                    </li>
                                    <li>
                                        Google y Facebook para permitirte iniciar sesión fácilmente.
                                    </li>
                                </ul>
                                <p className="mt-1">
                                    Estos servicios pueden recopilar cierta información técnica sobre tu visita.
                                </p>
                            </li>
                            <li>
                                <span className="font-semibold">¿Usamos cookies?</span>
                                <ul className="list-disc list-inside ml-5 mt-1 space-y-1">
                                    <li>Recordar tus preferencias.</li>
                                    <li>Mostrarte publicidad más relevante.</li>
                                </ul>
                                <p className="mt-1">
                                    Puedes controlar el uso de cookies desde la configuración de tu navegador.
                                </p>
                            </li>
                            <li>
                                <span className="font-semibold">¿Compartimos tu información?</span>
                                <p className="mt-1">
                                    No compartimos tu información personal con terceros. Cuando analizamos los datos, lo hacemos de forma anónima y despersonalizada para que no se pueda saber a quién pertenecen.
                                </p>
                            </li>
                            <li>
                                <span className="font-semibold">¿Cómo protegemos tus datos?</span>
                                <ul className="list-disc list-inside ml-5 mt-1 space-y-1">
                                    <li>Toda la comunicación en Carriapp está protegida con SSL.</li>
                                    <li>Nuestras bases de datos están alojadas de forma segura y no se puede acceder a ellas desde fuera.</li>
                                    <li>Solo personas autorizadas pueden acceder a los datos.</li>
                                </ul>
                            </li>
                            <li>
                                <span className="font-semibold">¿Puedo ver o modificar mis datos?</span>
                                <p className="mt-1">
                                    Sí. Puedes acceder y corregir tu información en cualquier momento desde tu perfil. Pronto también podrás eliminar tu cuenta.
                                </p>
                            </li>
                            <li>
                                <span className="font-semibold">¿Pueden usar Carriapp los menores de edad?</span>
                                <p className="mt-1">
                                    No. Carriapp está pensada solo para personas mayores de edad.
                                </p>
                            </li>
                            <li>
                                <span className="font-semibold">¿Cambios en esta política?</span>
                                <p className="mt-1">
                                    Si actualizamos esta política, te avisaremos por correo y también verás una notificación cuando entres al sitio.
                                </p>
                            </li>
                            <li>
                                <span className="font-semibold">¿Tienes dudas?</span>
                                <p className="mt-1">
                                    Puedes escribirnos a: <a href="mailto:contacto@carriapp.cl" className="text-blue-600 underline">contacto@carriapp.cl</a>
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </main>
        </>
    )
}